export const FOLDER_NOT_SELECTED = -1;

export function hasCheckedFolder(checkedId: number): boolean {
	return checkedId !== FOLDER_NOT_SELECTED;
}
